// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ArticleSchema from './article-schema';

const schema = {
  $id: '/basket-item-schema',
  type: 'object',
  required: ['count'],
  properties: {
    count: {
      type: 'integer',
    },
    article: {
      ...ArticleSchema,
    },
  },
} as IJSONSchema;

export default schema;
